var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-4"
  }, [_c('h4', {
    staticClass: "mb-2"
  }, [_vm._v(" Layout Blank ")]), _c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('div', {
    staticClass: "alert-body"
  }, [_c('p', [_c('strong', [_vm._v("Info: ")]), _c('span', [_vm._v("This layout is used in Authentication & Miscellaneous page. Please check the ")]), _c('b-link', {
    staticClass: "alert-link",
    attrs: {
      "href": "https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/guide/layout/page-layout-examples.html#layout-blank",
      "target": "_blank"
    }
  }, [_vm._v("Layout Blank documentation")]), _c('span', [_vm._v(" for more details.")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }